import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';

const StyledIcon = styled.i
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--icon-color': props.theme.property(`palette.${props.$color}`)?.main ?? props.theme.property(`palette.${props.$color}`),
      '--icon-disabled-color': props.theme.property('palette.action.disabled')
    };

    return utils.styleProps(attr, vars);
  })`
  
  &.Icon-color {
    color: ${props => props.$css.$var('--icon-color')};
  }
  ${props => props.theme.state2Selector('Icon', null, 'disabled')} {
    pointer-events: none;
    color: ${props => props.$css.$var('--icon-disabled-color', false)} !important;
  }
  
  // sizes
  &.Icon-size-micro {
    font-size: ${props => props.theme.fontSize(6)} !important;
  }
  &.Icon-size-mini {
    font-size: ${props => props.theme.fontSize(8)} !important;
  }
  &.Icon-size-tinier {
    font-size: ${props => props.theme.fontSize(10)} !important;
  }
  &.Icon-size-tiny {
    font-size: ${props => props.theme.fontSize(12)} !important;
  }
  &.Icon-size-smallest {
    font-size: ${props => props.theme.fontSize(14)} !important;
  }
  &.Icon-size-smaller {
    font-size: ${props => props.theme.fontSize(16)} !important;
  }
  &.Icon-size-small {
    font-size: ${props => props.theme.fontSize(20)} !important;
  }
  &.Icon-size-medium {
    font-size: ${props => props.theme.fontSize(24)} !important;
  }
  &.Icon-size-large {
    font-size: ${props => props.theme.fontSize(35)} !important;
  }
  &.Icon-size-larger {
    font-size: ${props => props.theme.fontSize(48)} !important;
  }
  
  ${ComponentStyles}
`;

StyledIcon.propTypes = {
  theme: PropTypes.object
};

export default StyledIcon;
